import i18n from '../../../i18n/i18n';
import Helper from '../helper';

export default class DropdownComponent {
  constructor(config) {
    this.translator = i18n;
    this.helper = new Helper();
    this.wrapper = null;
    this.input = null;
    this.label = null;
    this.list = null;
    this.values = {};
    this.currentValue = null;
    this.initialized = false;
    this.onChangeCallback = function() {};
    if (config != null) {
      this.initialized = this._init(config);
    }
  }

  _init(config) {
    if (this.wrapper != null) {
      return false;
    }
    if (config.hasOwnProperty('containerID')) {
      this.container = document.getElementById(config.containerID);
    }
    if (config.hasOwnProperty('container')) {
      this.container = config.container;
    }
    if (this.container == null) {
      console.warn('No container element for Dropdown found.');
      return false;
    }
    this._createElements();
    if (config.hasOwnProperty('values')) {
      this.values = config.values;
      for (const [key, value] of Object.entries(config.values)) {
        this._createListElement(key, value);
      }
      if (config.hasOwnProperty('defaultKey')) {
        this.currentKey = config.defaultKey;
      } else {
        [this.currentKey] = Object.keys(config.values);
      }
      this._updateLabel();
    }
    this.container.appendChild(this.wrapper);
    return true;
  }

  _createElements() {
    // wrapper
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('dropdown');
    this.wrapper.id = this.helper.findFreeHTMLId('dropdown');

    // checkbox
    this.input = document.createElement('input');
    this.input.type = 'checkbox';
    this.input.id = this.helper.findFreeHTMLId('dropdown-toggle');
    this.wrapper.appendChild(this.input);

    // label
    this.label = document.createElement('label');
    this.label.htmlFor = this.input.id;
    this.wrapper.appendChild(this.label);

    // label
    this.list = document.createElement('ul');
    this.wrapper.appendChild(this.list);
  }

  _createListElement(key, value) {
    const li = document.createElement('li');
    li.dataset.key = key;
    li.dataset.value = value;
    li.onclick = () => this._listElementClicked(li);
    li.innerHTML = value;
    this.list.appendChild(li);
  }

  _listElementClicked(element) {
    this.currentKey = element.dataset.key;
    this.input.checked = !(this.input.checked);
    this._updateLabel();
    this.onChangeCallback({ key: element.dataset.key, value: element.dataset.value });
  }

  _updateLabel() {
    if (!this.values.hasOwnProperty(this.currentKey)) {
      this.label.innerHTML = ' - ';
      return;
    }
    this.label.innerHTML = this.values[this.currentKey];
  }

  getKey() {
    return this.currentKey;
  }

  getValue() {
    if (!this.values.hasOwnProperty(this.currentKey)) {
      return null;
    }
    return this.values[this.currentValue];
  }

  updateList(values) {
    if (this.initialized !== true) {
      return false;
    }
    while (this.list.hasChildNodes()) {
      this.list.removeChild(this.list.lastChild);
    }
    for (const [key, value] of Object.entries(values)) {
      this._createListElement(key, value);
    }
    return true;
  }
}
